export default "__VITE_ASSET__BwyfpATR__"